import React from 'react'
import './Checkout.css'


const Checkout = () => {

    

    return (
        <div>
            <p className='paraCheckout'>we're sorry but this store is not real, maybe you can fry your egg instead?</p>
            <img src='./banksy.jpg' alt='banksy chicken' className='imgCheckout'/>
            
        </div>
    )
}

export default Checkout
